// In-flight request deduplication.
// If two components request the same data simultaneously, only one fetch fires.
// The second caller gets the same promise. Cleared once the request completes.

const inFlight = new Map<string, Promise<any>>();

export function dedup<T>(key: string, fn: () => Promise<T>): Promise<T> {
  const existing = inFlight.get(key);
  if (existing) return existing;

  const promise = fn().finally(() => inFlight.delete(key));
  inFlight.set(key, promise);
  return promise;
}
